<div class="login-form" *ngIf="step == 'login'">
  <!-- <div class="form-group">
    <a href="javascript:;" (click)="loginFacebook()"
      ><button type="button" class="btn btn-primary btn-lg btn-block">
        <i class="fa fa-facebook"></i> Continuar com Facebook
      </button></a
    >
  </div> -->
  <div class="social-login">
    <!-- href="https://reachr-linkedin-login-806463911775.us-central1.run.app?client_id=77hxwubktxlv3r&client_secret=iuA4Z8fwlaJR9Yue" -->
    <a
      class="btn btn-social"
      (click)="salvarParametros()"
      href="https://reachr-linkedin-login-806463911775.us-central1.run.app"
    >
      <i class="fab fa-linkedin social-icon linkedin" aria-hidden="true"></i>
      <span>Continuar com LinkedIn</span>
      <span class="ultimo-usado" *ngIf="ultimoLogin == 'linkedin'">Você utilizou por último</span>
    </a>

    <div class="dropdown" *ngIf="tipoConta != 'candidato'">
      <button
        class="btn btn-social dropdown-toggle"
        type="button"
        data-toggle="dropdown"
        aria-expanded="false"
      >
        <i class="fab fa-microsoft social-icon microsoft" aria-hidden="true"></i>
        <span>Continuar com Microsoft</span>
        <span class="ultimo-usado" *ngIf="ultimoLogin == 'microsoft'">Você utilizou por último</span>
      </button>
      <div class="dropdown-menu">
        <a
          class="dropdown-item"
          href="https://service-integracao-sso-rearch.azurewebsites.net/Auth/Login"
        >
          Entrar com o e-mail Reachr
        </a>
        <a
          class="dropdown-item"
          href="https://service-integracao-sso-sesc-dmhzgva7hvhydtaa.eastus-01.azurewebsites.net/Auth/Login"
        >
          Entrar com o e-mail SESC
        </a>
      </div>
    </div>
  </div>

  <div class="divisor"><span>ou entre com seu e-mail</span></div>

  <form
    class="signup"
    (ngSubmit)="newLogin(formdata)"
    [formGroup]="formdata"
    method="post"
    novalidate
  >
    <div class="campo">
      <label for="userName">E-mail</label>
      <input
        id="userName"
        class="form-control"
        formControlName="userName"
        name="userName"
        placeholder="seu@email.com"
        autocomplete="email"
        required
        type="email"
      />
      <div
        *ngIf="userName.errors && (userName.dirty || userName.touched)"
        class="erro-campo"
      >
        <span *ngIf="userName.errors.required">Insira o e-mail</span>
        <span *ngIf="userName.errors.pattern">Verifique seu e-mail</span>
      </div>
    </div>

    <div class="campo">
      <div class="campo-topo">
        <label for="password">Senha</label>
        <a
          class="link-esqueci"
          href="javascript:void(0)"
          [routerLink]="[]"
          (click)="abrirFormularioEsqueceuSenha()"
          >Esqueci minha senha</a
        >
      </div>
      <div class="campo-senha">
        <input
          id="password"
          class="form-control"
          [type]="showPassword ? 'text' : 'password'"
          formControlName="password"
          name="password"
          placeholder="Sua senha"
          autocomplete="current-password"
          required
        />
        <button
          type="button"
          class="btn-mostrar-senha"
          (click)="showPassword = !showPassword"
          [attr.aria-label]="showPassword ? 'Ocultar senha' : 'Mostrar senha'"
          tabindex="-1"
        >
          <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
        </button>
      </div>
      <div
        *ngIf="password.errors && (password.dirty || password.touched)"
        class="erro-campo"
      >
        <span *ngIf="password.errors.required">Insira sua senha</span>
        <span *ngIf="password.errors.minlength">Mínimo 6 caracteres</span>
      </div>
    </div>

    <div class="alert alert-danger alerta" *ngIf="showLoginSenhaIncorreta">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Sua conta ou
      senha está incorreta.
    </div>

    <div class="alert alert-danger alerta" *ngIf="showLoginNaoConfirmado">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Seu endereço
      de e-mail ainda não foi confirmado, acesse seu e-mail e confirme sua conta
      no e-mail recebido da Reachr!
    </div>

    <button
      type="submit"
      class="btn btn-entrar"
      [class.carregando]="loading"
      [disabled]="userName == null || password == null || formdata.invalid || loading"
    >
      <span class="btn-spinner" *ngIf="loading" aria-hidden="true"></span>
      {{ loading ? 'Entrando…' : 'Entrar' }}
      <span class="ultimo-usado" *ngIf="ultimoLogin == 'email'">Você utilizou por último</span>
    </button>

    <!-- Convite para criar conta: o cartão inteiro é o link (o destino depende do perfil e da vaga). -->
    <ng-container *ngIf="mostrarLinkCadastro == true">
      <a
        class="convite-cadastro"
        href="{{ siteUrl }}/cadastrar"
        *ngIf="conta == 'empresa' && nextjobtoken == ''"
        ><ng-container *ngTemplateOutlet="conviteCadastro"></ng-container></a
      >
      <a
        class="convite-cadastro"
        href="{{ siteUrl }}/cadastrar?nextjobtoken={{ nextjobtoken }}"
        *ngIf="conta == 'empresa' && nextjobtoken != ''"
        ><ng-container *ngTemplateOutlet="conviteCadastro"></ng-container></a
      >

      <a
        class="convite-cadastro"
        href="{{ siteUrl }}/paracandidatos/cadastrar"
        *ngIf="conta == 'candidato' && nextjobvagaid == ''"
        ><ng-container *ngTemplateOutlet="conviteCadastro"></ng-container></a
      >
      <a
        class="convite-cadastro"
        href="{{ siteUrl }}/paracandidatos/cadastrar?nextjobvagaid={{
          nextjobvagaid
        }}"
        *ngIf="conta == 'candidato' && nextjobvagaid != ''"
        ><ng-container *ngTemplateOutlet="conviteCadastro"></ng-container></a
      >
    </ng-container>
    <ng-template #conviteCadastro>
      <span class="convite-icone" aria-hidden="true">
        <i class="fas" [ngClass]="conta == 'empresa' ? 'fa-building' : 'fa-user-plus'"></i>
      </span>
      <span class="convite-texto">
        <small>Não possui uma conta?</small>
        <strong>{{ conta == 'empresa' ? 'Cadastre sua empresa' : 'Cadastre seu perfil' }}</strong>
      </span>
      <span class="convite-seta" aria-hidden="true"></span>
    </ng-template>
  </form>
</div>

<div class="login-form" *ngIf="step == 'forgot'">
  <h4 class="titulo-recuperar">Recuperar senha</h4>
  <p class="texto-recuperar">
    Informe o e-mail da sua conta e enviaremos um link para você criar uma nova
    senha.
  </p>
  <div class="alert alert-success alerta" *ngIf="forgotSuccess">
    <i class="fa fa-check-square-o" aria-hidden="true"></i> Enviamos um link
    para seu e-mail. Lá você poderá escolher uma nova senha.
  </div>
  <div class="alert alert-danger alerta" *ngIf="forgotFail">
    <i class="fa fa-times-circle"></i> Não foi encontrado nenhuma conta
    cadastrada com esse e-mail.
  </div>

  <form [formGroup]="formdata">
    <div class="campo">
      <label for="forgot-email">E-mail</label>
      <input
        id="forgot-email"
        class="form-control"
        formControlName="userName"
        name="userName"
        placeholder="seu@email.com"
        autocomplete="email"
        required
        type="email"
      />
      <div
        *ngIf="userName.errors && (userName.dirty || userName.touched)"
        class="erro-campo"
      >
        <span *ngIf="userName.errors.required">Insira o e-mail</span>
        <span *ngIf="userName.errors.pattern">Verifique seu e-mail</span>
      </div>
    </div>

    <button
      class="btn btn-entrar"
      (click)="solicitarNovaSenha()"
      [class.carregando]="loading"
      [disabled]="userName.errors != null || loading"
    >
      <span class="btn-spinner" *ngIf="loading" aria-hidden="true"></span>
      {{ loading ? 'Enviando…' : 'Recuperar senha' }}
    </button>

    <p class="cadastrar">
      <a
        href="javascript:void(0)"
        [routerLink]="[]"
        (click)="abrirFormularioLogin()"
        ><i class="fa fa-arrow-left" aria-hidden="true"></i> Voltar para o
        login</a
      >
    </p>
  </form>
</div>
